import { makeStyles } from '@material-ui/core';
import { distances } from '../../../styles';

export const useSQuadrantStyles = makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  },
  grid: {
    flexGrow: 1,
    height: '100%',
    display: 'flex',
    padding: distances.base,
    paddingTop: 0
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    // Without this the content column can't shrink past its min-content width,
    // so a wide results table pushes the layout out of the viewport and gets
    // clipped instead of scrolling inside its own container (DEV-726).
    minWidth: 0
  },
  left: {
    paddingRight: distances.base
  },
  right: {
    paddingLeft: distances.base
  },
  order2: {
    order: 2
  },
  // Handed to the header, which places it beside its own title — see
  // SQuadrantHeaderControls. It shares toolbars with controls that flex, so
  // it must not shrink; padding sizes it close to the 40px pills around it.
  collapseButton: {
    flexShrink: 0,
    padding: 8,
    border: '1px solid #E2E2EA',
    backgroundColor: '#FFFFFF',
    color: '#5D7083',
    '&:hover': {
      backgroundColor: '#EEF0F2'
    }
  },
  topConatiner: {
    padding: spacing(2),
    width: '100%',
    height: 75,
    display: 'flex',
    alignItems: 'center'
  },
  bottomContainer: {
    position: 'relative',
    height: 100,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flexGrow: 1,
    minHeight: '0%'
  }
}));
